import axios from "utils/axios";

// Daftar wa_bot_schedules (reminder), difilter related_meeting_schedule_id / contact_id.
export const getWABotSchedules = (params) => {
  return axios.get(`/WA/botSchedules`, {
    params,
  });
};
